import { Injectable,  inject } from '@angular/core';
import dayjs from "dayjs";
import { RegisterFormService } from './register-form.service';
import { EditRouteService } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/components/daily-route-list/services';

@Injectable({ providedIn: 'root' })

export class SendCurrentRouteService {
    private _editRouteService = inject(EditRouteService);
    private _registerFormService = inject(RegisterFormService);
    
    private _editedCustomRouteData = this._editRouteService.editedCustomRouteData;
    
    getRoute(){
        const route = this._editedCustomRouteData();
        if (!this._registerFormService.isValidForm() && (!route?.dailyRoutes || route?.dailyRoutes?.length === 0)) {
            const invalids = this._registerFormService.getInvalidControls()?.map(e => e.controlName)?.join(',');
            return {
                'is_successful': false,
                'reason': `No se ha establecido los parametros para la creación de la ruta. Se necesitan los siguientes inputs: ${invalids}`
            }
        }

        if (!route?.dailyRoutes)
            return {
                'is_successful': false,
                'reason': 'Esperando la generación de la ruta desde backend'
            }

        if (route?.dailyRoutes?.length === 0)
            return {
                'is_successful': false,
                'reason': 'No se ha encontrado un ruta compatible desde backend'
            }
            
        const mappedRoute = route?.dailyRoutes?.map(dailyRoute => {
            const date = dayjs(dailyRoute.date)?.format('YYYY-MM-DD');
            const points = dailyRoute.points?.map(point => ({
                id: point.id,
                title: point?.title,
                type: point?.type,
                duration: point?.duration,
                startDate: dayjs(point?.startDate)?.format('YYYY-MM-DDTHH:mm:ss'),
                endDate: dayjs(point?.endDate)?.format('YYYY-MM-DDTHH:mm:ss'),
            }))
            return {
                date,
                startPoint: dailyRoute.startPoint?.address,
                endPoint: dailyRoute.endPoint ? dailyRoute.startPoint?.address : null,
                points
            }
        })
        console.log("Route:", mappedRoute)

        return {
            'is_successful': true,
            'content': mappedRoute
        }
    }

}